/*!
 * @license
 * Copyright 2016 Alfresco Software, Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation, Inject} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {DialogCommentComponent} from 'src/app/+home/+my-libraries/+sites/document-library/shared/dialog-comment/dialog-comment.component';
import {APIHelper} from 'src/shared/services/api-helper/api-helper.service';
import {ContentService} from 'src/shared/services/content.service';
import {CommentService} from '../services/comment.service';
import { MOMENT_TOKEN } from '../../shared/shared.module';
@Component({
  selector: 'adf-media-player',
  templateUrl: './mediaPlayer.component.html',
  styleUrls: ['./mediaPlayer.component.scss'],
  host: { class: 'adf-media-player' },
  encapsulation: ViewEncapsulation.None
})
export class MediaPlayerComponent implements OnChanges {
  @Input() elementId: string;
  @Input() parentId: string;
  @Input() fileName: string;
  @Input()
  urlFile: string;
  pdfThumbnailsContext:any;
  @Input()
  description:string;

  @Input()
  blobFile: Blob;

  @Input()
  mimeType: string;

  @Input()
  nameFile: string;
  @Input()
  isPublic: boolean;

  @Output()
  exit = new EventEmitter();

  public commentaire: string;
  public comments: any[];

  constructor(
    private contentService: ContentService,
    private api: APIHelper,
    private commentService: CommentService,
    private dialog: MatDialog,
    @Inject(MOMENT_TOKEN) public moment
  ) {}

  ngOnInit() {
    this.comments = [];
    this.commentService.getAllComment(this.elementId).then(res => {
      this.comments = res.items;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const blobFile = changes['blobFile'];
    if (blobFile && blobFile.currentValue) {
      this.urlFile = this.contentService.createTrustedUrl(this.blobFile);
      return;
    }

    if (!this.urlFile && !this.blobFile) {
      throw new Error('Attribute urlFile or blobFile is required');
    }
  }

  addComment() {
    const queries = '?reverse=true&startIndex=0&pageSize=10';
    const data = {
      content: this.commentaire
    };
    this.commentService.createComment(data, this.elementId).then(
      res => {
        this.comments.push(res.item);
        this.commentaire = '';
      },
      err => {}
    );
  }

  public comment() {
    const dialogRef = this.dialog.open(DialogCommentComponent, {
      width: '40%',
      height: '30%',
      data: {
        elementId: this.elementId
      }
    });
  }
}
